"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZapTemplateCard = void 0;
exports.zapTemplateClicked = zapTemplateClicked;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _publish = _interopRequireDefault(require("../../../../components/tracker/publish"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function zapTemplateClicked(name, url) {
  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'App overview';

  _publish.default.trackEvent('userevent', {
    type: 'Zap template clicked',
    community_id: (0, _globals.default)('communityId'),
    template_location: location,
    template_name: name,
    template_url: url,
    user_id: (0, _insidedDataStorage.getInsidedData)('user').userid
  });
}

var ZapTemplateCard = function ZapTemplateCard(_ref) {
  var title = _ref.title,
      description = _ref.description,
      appLink = _ref.appLink,
      imageName = _ref.imageName,
      name = _ref.name,
      url = _ref.url,
      location = _ref.location;
  return (0, _preact.h)("a", {
    className: "integration-app-card-container",
    target: "_blank",
    rel: "noreferrer",
    href: (0, _absoluteUrlRuntime.resolveUrl)(appLink),
    onClick: function onClick() {
      return zapTemplateClicked(name, url, location);
    }
  }, (0, _preact.h)("div", {
    className: "app-card-header-container"
  }, imageName && (0, _preact.h)("div", {
    className: "app-card-image-wrapper"
  }, (0, _preact.h)("img", {
    height: 40,
    width: 40,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath'), "images/integrations/").concat(imageName, ".png"))
  })), (0, _preact.h)("div", {
    className: "app-card-details-wrapper"
  }, (0, _preact.h)("div", {
    className: "app-card-title-wrapper"
  }, (0, _preact.h)("div", {
    className: "app-card-title"
  }, title), (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    icon: "byZapier",
    customClass: "app-card-by-zapier-icon",
    height: 16
  }))), (0, _preact.h)("div", {
    className: "app-description-container"
  }, description))));
};

exports.ZapTemplateCard = ZapTemplateCard;